'use strict';
// require('es6-promise').polyfill();
// import fetch from 'isomorphic-fetch';
import 'core-js/es6/promise';
import 'whatwg-fetch';

import config from 'config';
import { normalize } from 'normalizr';
import clrSso from 'clarity-ui-sso';
import schemas from 'schemas';
import _ from 'lodash';

const getResponseData  = (json, apiUrl) => {
  return _.contains(apiUrl, 'validate') ? Object.assign({}, {user: json}) : json;
}

const getNormalizedPayload = (json, apiUrl, schema) => {
  var jsonData = _.has(json, 'data') ? json.data : getResponseData(json, apiUrl);
  var payload = normalize(jsonData, schema);
  return _.has(json, 'errors') ? Object.assign(payload, {errors: json.errors}) : payload;
}

const isUnexpectedToken = (error) => {
  if (_.contains(error.toString().toLowerCase(), 'unexpected token')) {
    return true;
  } else {
    return false
  }
};

const dispatchError = (dispatch, error, failureType) => {
  if (isUnexpectedToken(error)) {
    clrSso.logout();
  }
  console.log('before', failureType);
  dispatch(
    Object.assign({}, {
      payload: {errors: [{message: error.toString() + '. ' + failureType}]},
      type: failureType
    })
  );
  console.log('after', failureType);
};

const dispatchFetch = (dispatch, apiUrl, fetchType, headers, schema, graphql, successType, failureType, hasPreviousError) => {
  var token = localStorage.getItem('token');
  var fetchContent = {
      method: fetchType,
      headers: headers
  };

  if (token) {
    headers.Authorization = token;
  }
  if (fetchType === 'post') {
    _.assign(fetchContent, {body: JSON.stringify(graphql)});
  }

  return fetch(apiUrl, fetchContent)
    .then(response => response.json())
    .then(
      json => {
        if (_.has(json, 'message') && (_.contains(json.message, 'Token is empty') || _.contains(json.message, 'Session has expired'))) {
          throw new Error('unexpected token');
        }
        console.log('before', successType);
        dispatch(
          Object.assign({}, {
            payload: getNormalizedPayload(json, apiUrl, schema),
            type: successType
          })
        )
        console.log('after', successType);
      }
    )
    .catch(
      error => {
        if (isUnexpectedToken(error) && !hasPreviousError) {
          return dispatchFetch(dispatch, apiUrl, fetchType, headers, schema, graphql, successType, failureType, true);
        } else {
          dispatchError(dispatch, error, failureType);
        }
      }
    );
};

export default function callAPIMiddleware({ dispatch, getState }) {

  return next => action => {
    // Non standard action.
    if (!action.payload) {
      return next(action);
    }

    const {
      requestTypes,
      remote = () => false,
      shouldCallAPI = () => true,
      schema = schemas,
      graphql = {}
    } = action.payload;

    // Normal action: pass it on
    if (!remote) {
      return next(action);
    }

    // Normal action: pass it on
    if (!requestTypes) {
      return next(action);
    }

    if (
      !Array.isArray(requestTypes) ||
      requestTypes.length !== 3 ||
      !requestTypes.every(requestTypes => typeof requestTypes === 'string')
    ) {
      throw new Error('Expected an array of three string types.');
    }

    if (!shouldCallAPI(getState())) {
      return;
    }

    const [ requestType, successType, failureType ] = requestTypes;

    /*eslint no-console: 0*/
    console.log('before', requestType, action.payload);
    dispatch(Object.assign({}, {
      payload: graphql,
      type: requestType
    }));
    console.log('after', requestType);

    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };

    var apiUrl = config.apiUrl;

    if (action.payload.isAuthAPI) {
      apiUrl = config.authApiUrl + action.payload.authApiName;
    }
    return new Promise((resolve) => {
      let ticks = 0;
      const inter = setInterval(() => {
        ticks++;
        const token = localStorage.getItem('token');
        if (token || ticks >= 10) {
          clearInterval(inter);
          dispatchFetch(dispatch, apiUrl, action.payload.fetchType, headers, schema, graphql, successType, failureType, false).then(resolve);
        }
      }, 50);
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/callAPIMiddleware.js